module.exports = __webpack_public_path__ + "img/Allyant-badge.07059ffe.svg";